import { render, staticRenderFns } from "./DesignerIconMenu.vue?vue&type=template&id=0b669058&scoped=true&"
import script from "./DesignerIconMenu.vue?vue&type=script&lang=ts&"
export * from "./DesignerIconMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DesignerIconMenu.vue?vue&type=style&index=0&id=0b669058&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b669058",
  null
  
)

export default component.exports